export default __webpack_public_path__ + "static/js.d0b72e056e6881f205d9e73152d5d01d.png";